/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator(), model);
        AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.newInstance(<AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Exploitability metric(s) scope v3.1 to include
     */
    scope_v31: Array<models.CvssV31ExploitabilityScope>;

}
